<ng-container *ngIf="!user.hasTinsAwaitingApproval">
  <div data-test="wam-table-status-registered" class="cg-color-success cg-bold">
    Registered
  </div>
  <div *ngIf="hasChcpAcccess(user)" class="cg-margin-top-xs">
    CignaforHCP.com
  </div>
  <div *ngIf="hasEvernorthAcccess(user)" class="cg-margin-top-xs">
    Provider.Evernorth.com
  </div>
</ng-container>

<ng-container *ngIf="user.hasTinsAwaitingApproval">
  <div class="cg-color-warn" data-test="wam-table-status-awaiting">
    Awaiting approval
  </div>
  <div class="cg-margin-top-xs">
    (Requested approval on {{ user.requestedDate | date: 'shortDate' }})
  </div>
  <div *ngIf="hasChcpAcccess(user)" class="cg-margin-top-xs">
    CignaforHCP.com
  </div>
  <div *ngIf="hasEvernorthAcccess(user)" class="cg-margin-top-xs">
    Provider.Evernorth.com
  </div>
</ng-container>

<div class="cg-margin-top-lg">
  <button
    *ngIf="canShowRemove(user)"
    cignaButton="link"
    style="padding: 0"
    data-test="wam-table-remove-access"
    (click)="removeAccessForUser.emit(user)"
  >
    Remove Access
  </button>
  <span *ngIf="canShowRemove(user) && canShowReset(user)"> | </span>
  <button
    *ngIf="canShowReset(user)"
    cignaButton="link"
    style="padding: 0"
    data-test="wam-table-reset-password"
    (click)="resetPasswordForUser.emit(user)"
  >
    Reset password
  </button>
</div>
